/**
 * 对话框事件定义
 * 薄DDD方案 - 通过事件总线解决循环依赖
 */
import { eventBus } from "../events/EventBus";

/**
 * 对话框事件名称
 */
export const DialogEvents = {
  // 标签管理对话框
  TAG_MANAGE_OPEN: "dialog:tag_manage:open",
  TAG_MANAGE_CLOSE: "dialog:tag_manage:close",

  // 标签表单对话框
  TAG_FORM_OPEN: "dialog:tag_form:open",
  TAG_FORM_CLOSE: "dialog:tag_form:close",

  // 标签标注对话框
  TAG_ANNOTATE_OPEN: "dialog:tag_annotate:open",
  TAG_ANNOTATE_CLOSE: "dialog:tag_annotate:close",
} as const;

/**
 * 对话框事件数据
 */
export interface DialogEventData {
  dialogId: string;
  action: "open" | "close";
  data?: unknown;
}

/**
 * 对话框管理器 - 使用事件总线
 */
export class DialogManager {
  /**
   * 打开对话框
   */
  static openDialog(dialogId: string, data?: unknown): void {
    eventBus.emit(DialogEvents.TAG_MANAGE_OPEN, {
      dialogId,
      action: "open",
      data,
    });
  }

  /**
   * 关闭对话框
   */
  static closeDialog(dialogId: string): void {
    eventBus.emit(DialogEvents.TAG_MANAGE_CLOSE, {
      dialogId,
      action: "close",
    });
  }

  /**
   * 监听对话框事件
   */
  static onDialogEvent(
    dialogId: string,
    callback: (data: DialogEventData) => void,
  ): () => void {
    return eventBus.on(
      DialogEvents.TAG_MANAGE_OPEN,
      (data: DialogEventData) => {
        if (data.dialogId === dialogId) {
          callback(data);
        }
      },
    );
  }

  /**
   * 监听标签管理对话框
   */
  static onTagManageDialog(callback: (isOpen: boolean) => void): () => void {
    let unsubscribeOpen = eventBus.on(DialogEvents.TAG_MANAGE_OPEN, () =>
      callback(true),
    );
    let unsubscribeClose = eventBus.on(DialogEvents.TAG_MANAGE_CLOSE, () =>
      callback(false),
    );

    return () => {
      unsubscribeOpen();
      unsubscribeClose();
    };
  }

  /**
   * 监听标签表单对话框
   */
  static onTagFormDialog(callback: (isOpen: boolean) => void): () => void {
    let unsubscribeOpen = eventBus.on(DialogEvents.TAG_FORM_OPEN, () =>
      callback(true),
    );
    let unsubscribeClose = eventBus.on(DialogEvents.TAG_FORM_CLOSE, () =>
      callback(false),
    );

    return () => {
      unsubscribeOpen();
      unsubscribeClose();
    };
  }

  /**
   * 监听标签标注对话框
   */
  static onTagAnnotateDialog(callback: (isOpen: boolean) => void): () => void {
    let unsubscribeOpen = eventBus.on(DialogEvents.TAG_ANNOTATE_OPEN, () =>
      callback(true),
    );
    let unsubscribeClose = eventBus.on(DialogEvents.TAG_ANNOTATE_CLOSE, () =>
      callback(false),
    );

    return () => {
      unsubscribeOpen();
      unsubscribeClose();
    };
  }
}
